<template>
  <v-container class="limited">
    <dados-beneficiario></dados-beneficiario>
    <guia-detalhe
      v-if="isDetalhe"
      @voltar="voltar"
      :guia-detalhe="guia"
    ></guia-detalhe>
    <guia-grid v-else @detalhar="detalhar"></guia-grid>
  </v-container>
</template>

<script>
import DadosBeneficiario from "@/components/BeneficiaryData";

import GuiaGrid from "./guia-grid";
import GuiaDetalhe from "./guia-detalhe";

export default {
  name: "Guias",
  components: {
    DadosBeneficiario,
    GuiaGrid,
    GuiaDetalhe
  },
  data() {
    return {
      guia: null,
      isDetalhe: false
    };
  },
  methods: {
    detalhar(guia) {
      this.guia = guia;
      this.isDetalhe = true;
    },
    voltar() {
      this.guia = null;
      this.isDetalhe = false;
    }
  }
};
</script>
